module.exports = __webpack_public_path__ + "images/emoji/cactus.4b7210a3aece9b77c29c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cactus.png
// module id = +KOE
// module chunks = 24